import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { EditUserBanner } from "../../styles/banners";
import {
  CenteredDegradedTitle,
  CenteredSubTitle,
  CenteredTitle,
  LeftBoxContent,
  LeftBoxSubTitle,
  LeftBoxTitle,
} from "../../styles/texts";
import {
  SolarPanelImage,
  InverterImage,
  InstallationImages,
  AdditionalImage,
} from "../../styles/images";
import { GrayBorderBox } from "../../styles/boxes";

import {
  UserData,
  UserBooking,
  SpecificBooking,
  UserContract,
  PostInstallationDocuments,
  PostInstallationMedia,
} from "../../types/responseTypes";

import { formatDate } from "./formatDate";

import { provisionalHomePictures } from "./provisional/provisionalMedia";
// import { provisionalAdditionalWorks } from "./provisional/provisionalMedia";
import { GrayButton } from "../../styles/buttons";

const InstallationDetail: React.FC = () => {
  const location = useLocation();

  const { userData, userBooking, specificBooking, bookingIndex, installationDocuments, installationMedia } = location.state as {
    userData: UserData;
    userBooking: UserBooking;
    specificBooking: SpecificBooking | null;
    userContract: UserContract | null;
    bookingIndex: number;
    installationDocuments: PostInstallationDocuments | null;
    installationMedia: PostInstallationMedia | null;
  };

  console.log("Installation Detail", userData, userBooking, specificBooking, bookingIndex);

  return (
    <div className="relative h-screen flex flex-col overflow-y-auto">
      <EditUserBanner userData={userData} backLink="/home" bookingIndex={bookingIndex} />
      <div className="flex flex-col justify-center items-center w-full mt-4 flex-1">
        <div className="w-[616px] h-auto flex flex-col items-center">
          <div className="mb-4">
            <CenteredDegradedTitle>Instalación Terminada!</CenteredDegradedTitle>
            <CenteredSubTitle>
              ¡Felicidades! Tu sistema solar ha sido instalado correctamente
            </CenteredSubTitle>
            <InstallationImages fetchedMedia={installationMedia} provisionalMedia={provisionalHomePictures} />
          </div>
          <CenteredTitle>Tu instalación</CenteredTitle>
          <CenteredSubTitle>
            Información relevante de tu instalación
          </CenteredSubTitle>
          <GrayBorderBox w="616px" h="113px" m="4px">
            <LeftBoxSubTitle>Dirección</LeftBoxSubTitle>
            <LeftBoxContent>{userBooking.address}</LeftBoxContent>
          </GrayBorderBox>
          <div className="flex flex-wrap justify-center items-center mb-8">
            <GrayBorderBox w="300px" h="113px" m="4px">
              <LeftBoxSubTitle>Potencia total</LeftBoxSubTitle>
              <LeftBoxContent>
                {specificBooking?.autoConsumption} mWh
              </LeftBoxContent>
            </GrayBorderBox>
            <GrayBorderBox w="300px" h="113px" m="4px">
              <LeftBoxSubTitle>Fecha término instalación</LeftBoxSubTitle>
              <LeftBoxContent>
                {formatDate(userBooking.bookingCreatedAt)}
              </LeftBoxContent>
            </GrayBorderBox>
          </div>
          <CenteredTitle>Tu sistema solar</CenteredTitle>
          <CenteredSubTitle>
            Detalles de los equipos que instalamos
          </CenteredSubTitle>
        </div>
        {/* Carousel */}
        <div className="w-full z-50 bg-white overflow-hidden">
          <div
            className="overflow-x-scroll flex snap-x snap-mandatory scroll-smooth"
            style={{
              scrollbarWidth: "none", // Hide horizontal scrollbar in Firefox
              msOverflowStyle: "none", // Hide horizontal scrollbar in IE
            }}
          >
            <style>{`
              ::-webkit-scrollbar {
                height: 0px; /* Hide horizontal scrollbar in WebKit browsers */
              }
            `}</style>
            <div
              className="snap-center flex-shrink-0"
              style={{ width: "calc(100vh - 313px)" }}
            />
            <div className="snap-center flex-shrink-0">
              <SolarPanelImage
                solarPanel={specificBooking?.solarPanel ?? null}
                specificBooking={specificBooking}
              />
            </div>
            <div className="snap-center flex-shrink-0">
              <InverterImage
                inverter={specificBooking?.inverter ?? null}
                specificBooking={specificBooking}
              />
            </div>
            <div
              className="snap-center flex-shrink-0"
              style={{ width: "calc(100vh - 313px)" }}
            />
          </div>
        </div>
        {/* Continuing main content */}
        {/* <div className="w-[616px] h-auto flex flex-col items-center mt-8"> */}
          {/* <CenteredTitle>Obras adicionales</CenteredTitle> */}
          {/* <CenteredSubTitle> */}
            {/* Para poder llevar a cabo tu instalación era necesario hacer obras adicionales. */}
            {/* Estas obras adicionales aseguraron el funcionamiento óptimo y seguro del sistema solar. */}
          {/* </CenteredSubTitle> */}
        {/* </div> */}
        {/* Carousel */}
        {/* <div className="w-full z-50 bg-white overflow-hidden"> */}
          {/* <div */}
            {/* className="overflow-x-scroll flex snap-x snap-mandatory scroll-smooth" */}
            {/* style={{ */}
              {/* scrollbarWidth: "none", // Hide horizontal scrollbar in Firefox */}
              {/* msOverflowStyle: "none", // Hide horizontal scrollbar in IE */}
            {/* }} */}
          {/* > */}
            {/* <style>{` */}
              {/* ::-webkit-scrollbar { */}
                {/* height: 0px;¿ */}
              {/* } */}
            {/* `}</style> */}
            {/* <div */}
              {/* className="snap-center flex-shrink-0" */}
              {/* style={{ width: "calc(100vh - 313px)" }} */}
            {/* /> */}
            {/* <div className="snap-center flex-shrink-0"> */}
              {/* <AdditionalImage */}
                {/* additonalWork={provisionalAdditionalWorks[0]} */}
              {/* /> */}
            {/* </div> */}
            {/* <div className="snap-center flex-shrink-0"> */}
              {/* <AdditionalImage */}
                {/* additonalWork={provisionalAdditionalWorks[1]} */}
              {/* /> */}
            {/* </div> */}
            {/* <div className="snap-center flex-shrink-0"> */}
              {/* <AdditionalImage */}
                {/* additonalWork={provisionalAdditionalWorks[2]} */}
              {/* /> */}
            {/* </div> */}
            {/* <div */}
              {/* className="snap-center flex-shrink-0" */}
              {/* style={{ width: "calc(100vh - 313px)" }} */}
            {/* /> */}
          {/* </div> */}
        {/* </div> */}
        {/* Continuing main content */}
        <div className="w-[616px] h-auto flex flex-col items-center mt-8">
          <CenteredTitle>Manual de operación</CenteredTitle>
          <CenteredSubTitle>
            Aquí encontrarás las mejores prácticas para el uso de tu sistema solar,
            detalles sobre su funcionamiento, consejos para su mantención y toda la información esencial
            para maximizar el rendimiento y la vida útil de tu nuevo sistema solar.
          </CenteredSubTitle>
          <GrayBorderBox w="616px" h="113px" m="4px">
            <div className="flex items-center justify-between w-full h-full gap-2">
              <div>
                <LeftBoxTitle>Manual de operación</LeftBoxTitle>
                <LeftBoxSubTitle>Document</LeftBoxSubTitle>
              </div>
              <GrayButton
                label="Descargar"
                h="44px"
                icon="paper"
                onClick={() =>
                  window.open("https://ruuf-front-public.s3.amazonaws.com/public-documents/Manual+de+operación+y+mantenimiento+Ruuf.pdf", "_blank")
                }
              />
            </div>
          </GrayBorderBox>
          <div className="w-full h-16" />
        </div>
      </div>
    </div>
  );
};

export default InstallationDetail;
